import useTranslation from 'hooks/useTranslation/useTranslation';
import { useState } from 'react';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import WizardModalTemplate, { WizardStep } from 'v2/components/WizardModal/WizardModalTemplate';
import useApiKeys from 'v2/hooks/useApiKeys/useApiKeys';
import ApiDetailsStep from './ApiDetailsStep';
import FinishStep from './FinishStep';
import GeneratingKeyStep from './GeneratingKeyStep';

const AddApiKeyWizard = () => {
  const { translation } = useTranslation();
  const { showSnackbar } = useSnackbarContext();
  const { restApiKeys, addApiKey } = useApiKeys({
    translation,
    handleFetchError: (msg) => showSnackbar(msg, { severity: 'error' })
  });

  const existingNames = restApiKeys.map((key) => key.description);

  const [pendingName, setPendingName] = useState('');
  const [generatedKey, setGeneratedKey] = useState<string | null>(null);

  const steps: WizardStep[] = [
    { label: translation.api_details },
    { label: translation.generating_key },
    { label: translation.finish }
  ];

  return (
    <WizardModalTemplate title={translation.add_api_key} steps={steps} id="add-api-key-wizard">
      <ApiDetailsStep onProceed={setPendingName} existingNames={existingNames} />
      <GeneratingKeyStep name={pendingName} onGenerated={setGeneratedKey} addApiKey={addApiKey} />
      <FinishStep apiKey={generatedKey} />
    </WizardModalTemplate>
  );
};

export default AddApiKeyWizard;
